import http from "@/http-common";

class Intervals {
  putIntervals(id_local_review, interval_id, local_interval) {
    return http.put(
      `reviews/${id_local_review}/interval/${interval_id}`,
      local_interval
    );
  }
}

export default new Intervals();
